module.exports = __webpack_public_path__ + "img/chadle2_3.906c930d.png";